import { render, staticRenderFns } from "./EditLoyalty.vue?vue&type=template&id=3876e072&scoped=true&"
import script from "./EditLoyalty.vue?vue&type=script&lang=js&"
export * from "./EditLoyalty.vue?vue&type=script&lang=js&"
import style0 from "./EditLoyalty.vue?vue&type=style&index=0&id=3876e072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3876e072",
  null
  
)

export default component.exports